function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#C3C3E1;}\r\n\t.st1{fill:#8B8CC4;}\r\n\t.st2{fill:#6E6FAC;}\r\n\t.st3{fill:#E1DFDD;}\r\n\t.st4{fill:url(#SVGID_1_);}\r\n\t.st5{fill:#605D5A;}\r\n\t.st6{fill:#BF8F68;}\r\n\t.st7{fill:#DCB38B;}\r\n\t.st8{fill:url(#SVGID_2_);}\r\n\t.st9{fill:#FFFFFF;}\r\n\t.st10{fill:#F7B548;}\r\n\t.st11{fill:none;stroke:#EAEAF3;stroke-width:1.0652;stroke-miterlimit:10;}\r\n\t.st12{fill:#C8C6C4;}\r\n\t.st13{fill:#9B643D;}\r\n\t.st14{fill:url(#SVGID_3_);}\r\n\t.st15{fill:url(#SVGID_4_);}\r\n\t.st16{fill:#33312D;}\r\n\t.st17{opacity:0.6;fill:#231F20;enable-background:new    ;}\r\n\t.st18{fill:#F8F8F8;}\r\n\t.st19{fill:#594539;}\r\n\t.st20{fill:url(#SVGID_5_);}\r\n\t.st21{fill:#E0BB95;}\r\n\t.st22{fill:url(#SVGID_6_);}\r\n\t.st23{fill:url(#SVGID_7_);}\r\n\t.st24{fill:none;stroke:#8B8CC4;stroke-width:1.3393;stroke-miterlimit:10;}\r\n\t.st25{fill:#FFD590;}\r\n\t.st26{fill:none;stroke:#8B8CC4;stroke-width:2.1806;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st27{fill:url(#SVGID_8_);}\r\n\t.st28{fill:#797673;}\r\n\t.st29{fill:#FADCBD;}\r\n\t.st30{fill:url(#SVGID_9_);}\r\n\t.st31{fill:url(#SVGID_10_);}\r\n\t.st32{fill:url(#SVGID_11_);}\r\n\t.st33{fill:#BE906B;}\r\n\t.st34{fill:url(#SVGID_12_);}\r\n\t.st35{fill:#9A6541;}\r\n\t.st36{fill:#F3F2F1;}\r\n\t.st37{fill:url(#SVGID_13_);}\r\n\t.st38{fill:url(#SVGID_14_);}\r\n\t.st39{fill:url(#SVGID_15_);}\r\n\t.st40{fill:url(#SVGID_16_);}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M43.1,3.4l0.1,96.6h146.3l-0.1-99.8h-143C44.6,0.1,43.1,1.6,43.1,3.4L43.1,3.4z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M38.5,72.5c0.1,15.1,7.4,10.7,6.2,38.5c8-9.1,11.6-22.2,6.2-37.7C48.6,66.8,42,71.4,38.5,72.5z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M50.9,73.2c-0.1-0.9-2.2-2.8-4-2.7c-2.8,0.2-4.6,3.2-6.1,5.4c-4.5,6.7-11.1,4-11.1,4s1.1-0.9,2.2-3.5 c1.5-3.8,0.8-5.5,3.5-6.5c1.1-0.4,3.1,0.1,5.2-0.2c2.5-0.4,4.6-2.4,7.6-0.5C50,70.3,50.9,73.2,50.9,73.2z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M49,112.7c0,0,11.6-18,14.1-24.9c3.2-8.9,5.8-13,5.8-13S55.9,78,50.9,86C45.9,94,49,112.7,49,112.7z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M50.9,86c-3.1,4.9-3.1,13.9-2.6,20.1c4-6.4,6-14.2,4.9-22.9C52.3,84.1,51.5,85,50.9,86z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M54.5,109.7c3.3-3.4,5-6.8,9.8-8.3c6-1.9,6.6-4.5,11.1-9.3c-5.7,0.7-10.1-0.3-13.4,1.4 C55.6,96.9,55.8,103.9,54.5,109.7z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M188.9,84.5c-4.7-8.2-15.5-9.7-15.5-9.7s2.5,4.1,5.7,13c2.4,6.8,14.1,24.9,14.1,24.9S193.8,93.1,188.9,84.5 L188.9,84.5z"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M182.1,94.6c-4.1-2.1-8.7-0.9-13.4-1.4c4.5,4.8,5.1,7.5,11.1,9.3c4.8,1.5,6.5,4.9,9.8,8.3 C188.4,105,188.6,98,182.1,94.6L182.1,94.6z"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M189.5,0.1l0.1,99.8h146.3l-0.1-96.6c0-1.8-1.4-3.2-3.3-3.2C332.4,0.1,189.5,0.1,189.5,0.1z"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M305,88.4c-3.6-8.1-8.2-14.4-13.8-18.9c-5.2-4.1-12.7-6.1-17-7.1c-1.7-0.2-3.5-0.2-5.2-0.1 c-2.8-0.4-6.1-0.7-9.5-0.7c-3.4,0-6.6,0.2-9.3,0.6c-1.4,0-2.8,0-4.3,0.2c-4.3,1-11.8,3-17,7.1c-5.7,4.5-10.3,10.8-13.8,18.9 c-2,4.6-3.3,9.9-3.8,15.7c-0.8,10.2,98.2,10.7,97.5,0.6C308.4,98.6,307.1,93.2,305,88.4L305,88.4z"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M242.8,63.1V123h-6v-58C238.9,64.2,241,63.6,242.8,63.1z M281.2,64.3V123h-6V62.6C277,63,279,63.6,281.2,64.3 L281.2,64.3z"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M243.3,39l31.2,0.2l0.1-12.7c0-3.1-2.5-5.7-5.6-5.7c0,0,0,0,0,0l-19.9-0.1c-3.1,0-5.7,2.5-5.7,5.6c0,0,0,0,0,0 L243.3,39z"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M269.9,36h-21l0.1,22.4c0,1.5-1,2.5-1.7,2.8c7.2,5.7,18.7,4,24.5,0c-0.9-0.1-1.7-1.9-1.7-3.8L269.9,36z"
});
var _ref16 = /*#__PURE__*/React.createElement("circle", {
  className: "st7",
  cx: 245.6,
  cy: 39.6,
  r: 4.6
});
var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.1602 -0.9871 0.9871 0.1602 189.8905 302.1699)",
  className: "st7",
  cx: 272.5,
  cy: 39.5,
  rx: 4.6,
  ry: 4.6
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M256.2,57.3l5.2,0c6.2,0,11.2-5,11.3-11.2l0.1-15.4c0-3.3-2.6-6-5.9-6l-15.4-0.1c-3.4,0-6.1,2.7-6.2,6.1 l-0.1,15.4C245.2,52.2,250.1,57.2,256.2,57.3z"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M244,25.2c0,0,3.3-1.7,3.5,3.9c0.1,3.3-1,5-1.9,5.4c-0.9,0.4-1.5,0.4-1.5,0.4L244,25.2L244,25.2z"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M255,47.2l7.7,0c4.9,0,8.9-3.9,8.9-8.8l0-8.6c0-2.6-2.1-4.7-4.7-4.8c0,0,0,0,0,0L251.2,25 c-2.7,0-4.9,2.1-4.9,4.8l0,8.6C246.3,43.2,250.2,47.2,255,47.2z"
});
var _ref21 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(5.497802e-03 -1 1 5.497802e-03 224.9383 301.325)",
  className: "st5",
  cx: 264,
  cy: 37.6,
  rx: 2,
  ry: 1.1
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M253.3,29c4-0.8,5.7-2.4,9.7-3.1c6.7-1,7.7,0.9,7.7,0.9l1.2-1.9c-0.2-4.6-2.8-8.9-8-8.1c-8,1.2-5.3-1-8.8-1.2 c-3.2-0.2-4,3-5.3,3.3c-3.1,0.7-3.2-5.3-7.6-3.3C238.3,17.4,235.7,32.5,253.3,29z"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M247.6,51.8l11.1,0l0-6.1c0-0.5-0.3-1-0.7-1.3l-2.2-1.4c-0.5-0.3-0.6-1-0.3-1.4l1.9-3c0.5-0.7,0.7-1.5,0.7-2.4 l0-7.8l-11.1,0C247,28.3,247.6,51.8,247.6,51.8z"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M273.9,25.5c0,0-4.7-2.9-4.9,2.6c-0.1,3.3,1.6,5.2,2.7,6.2c0.7,0.7,2.2,0.7,2.2,0.7L273.9,25.5L273.9,25.5z"
});
var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(5.497802e-03 -1 1 5.497802e-03 214.2328 290.5626)",
  className: "st5",
  cx: 253.2,
  cy: 37.6,
  rx: 2,
  ry: 1.1
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M263.3,47.5c-0.1,0.7-0.5,1.4-1.1,1.9c-0.6,0.5-1.3,0.8-2.1,1c-0.8,0.1-1.6,0-2.3-0.3 c-0.7-0.3-1.3-0.9-1.5-1.7c-0.1-0.2,0.1-0.5,0.3-0.5c0.1,0,0.2,0,0.3,0l0.1,0c0.6,0.2,1,0.3,1.5,0.4c0.5,0,0.9,0,1.4,0 c0.5-0.1,0.9-0.2,1.4-0.4c0.5-0.2,0.9-0.4,1.5-0.7l0,0c0.2-0.1,0.5,0,0.6,0.2C263.3,47.3,263.3,47.4,263.3,47.5L263.3,47.5z"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M259.5,51.5c-0.7,0-1.5-0.2-2.1-0.5c-1.1-0.5-1.8-1.3-2.1-2.3c-0.1-0.4-0.1-0.8,0.1-1.1 c0.3-0.5,0.8-0.8,1.3-0.8c0.2,0,0.4,0,0.5,0.1c0.5,0.2,0.9,0.3,1.3,0.3c0.1,0,0.3,0,0.5,0c0.2,0,0.5,0,0.7,0c0.8-0.1,1.5-0.4,2.5-1 c0.3-0.2,0.5-0.2,0.8-0.2c0.5,0,1,0.3,1.3,0.7c0.2,0.3,0.2,0.7,0.2,1c-0.2,0.9-0.7,1.8-1.5,2.5c-0.7,0.6-1.6,1-2.6,1.2 C260,51.5,259.8,51.5,259.5,51.5L259.5,51.5z"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M262.9,47.1c0.2,0,0.4,0.2,0.4,0.4c0,0,0,0,0,0.1c-0.1,0.7-0.5,1.4-1.1,1.9c-0.6,0.5-1.3,0.8-2.1,1 c-0.2,0-0.4,0-0.6,0c-0.6,0-1.2-0.1-1.7-0.4c-0.7-0.3-1.3-0.9-1.5-1.7c-0.1-0.2,0.1-0.5,0.3-0.5c0.1,0,0.2,0,0.3,0l0.1,0 c0.7,0.3,1.4,0.4,2.1,0.4c0.3,0,0.6,0,0.8-0.1c0.9-0.1,1.8-0.4,2.8-1.1l0,0C262.7,47.1,262.8,47.1,262.9,47.1 M262.9,44.9 c-0.5,0-0.9,0.1-1.3,0.4c-1,0.6-1.5,0.8-2.1,0.8l0,0l0,0c-0.2,0-0.3,0-0.5,0c-0.4,0-0.9-0.1-1.3-0.2l-0.1,0 c-0.5-0.2-1.1-0.2-1.6-0.1c-0.7,0.2-1.2,0.6-1.5,1.2c-0.3,0.6-0.4,1.3-0.2,1.9c0.4,1.3,1.4,2.4,2.7,3c0.8,0.4,1.7,0.6,2.6,0.6 c0.3,0,0.6,0,0.9-0.1l0,0l0,0c1.2-0.2,2.3-0.7,3.2-1.5c0.9-0.8,1.6-1.9,1.8-3.1c0.1-0.6,0-1.2-0.3-1.7 C264.6,45.4,263.8,44.9,262.9,44.9z"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M271.3,71.1h-23.6c-0.8,0-1.4-0.6-1.4-1.4v0v-11c0-0.8,0.6-1.4,1.4-1.4c0,0,0,0,0,0h23.6 c0.8,0,1.4,0.6,1.4,1.4v11C272.7,70.5,272.1,71.1,271.3,71.1z"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M266.4,68.5l-7.5-3.7l-7.5,3.7c-0.7,0.4-1.5-0.3-1.5-1.2V60c0-0.9,0.8-1.6,1.6-1.2l7.5,3.7l7.5-3.7 c0.7-0.4,1.6,0.3,1.6,1.2v7.2C268,68.2,267.2,68.8,266.4,68.5L266.4,68.5z"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M276.5,66.7c-0.3-0.5-0.8-0.9-1.4-1l-6.1-1.4c-0.5-0.1-1,0.1-1.2,0.6l-2,3.4c-0.2,0.3-0.1,0.8,0.3,1 c0.3,0.2,0.7,0.1,0.9-0.2l1.7-2.5l3.7,0.8l-4.7,0.6l-0.3,1c-0.4,1.6-0.4,3.3,0,4.9l0.3,1c0.1,0.3,0.4,0.5,0.7,0.4 c0.2,0,0.3-0.2,0.4-0.3l1.1-1.6l2.2,0.3c0,0,0.3,2.8,2.4,4.9c2.1,2.1,5.6,4,5.6,4l3.6-3.3L276.5,66.7L276.5,66.7z"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M283.6,79.1l-7,5.7l16,40.1l19.2-12.7L283.6,79.1z"
});
var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M287.2,83.3l-8.4,6.8"
});
var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M241.4,67.2c0.3-0.5,0.8-0.9,1.3-1.1l6-1.6c0.5-0.1,1,0.1,1.2,0.5l2.1,3.3c0.2,0.3,0.1,0.8-0.2,1 c-0.3,0.2-0.7,0.1-1-0.2l-1.8-2.4l-3.7,0.9l4.7,0.4l0.3,1c0.5,1.6,0.5,3.3,0.2,4.9l-0.2,1c-0.1,0.3-0.4,0.5-0.7,0.5 c-0.2,0-0.3-0.2-0.4-0.3l-1.2-1.6l-2.2,0.4c0,0-0.2,2.8-2.2,5c-2,2.2-5.4,4.2-5.4,4.2l-3.8-3.2L241.4,67.2L241.4,67.2z"
});
var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M234.7,79.8l7,5.7l-16,40.1l-19.2-12.7L234.7,79.8z"
});
var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M231.2,83.9l8.4,6.8"
});
var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M284.9,39.3h23.4v-0.6c0-5.7-4.6-10.3-10.3-10.4c0,0-0.1,0-0.1,0h-2.7c-5.7,0-10.3,4.6-10.4,10.3 c0,0,0,0.1,0,0.1L284.9,39.3L284.9,39.3z"
});
var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M323.4,101h-2.2V27.4c0-5.6-4.5-10.1-10.1-10.1c0,0,0,0,0,0h-3.6c-5.6,0-10.1,4.5-10.1,10.1c0,0,0,0,0,0v4 h-2.2v-4c0-6.8,5.5-12.3,12.3-12.3h3.6c6.8,0,12.3,5.5,12.3,12.3L323.4,101L323.4,101z"
});
var _ref39 = /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 296.6,
  cy: 38.7,
  r: 4.4
});
var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M301,38.7v0.6h-8.7c0-0.1-0.1-0.4-0.1-0.6c0-2.4,1.9-4.4,4.3-4.4c0,0,0,0,0.1,0C299.1,34.3,301,36.3,301,38.7 C301,38.7,301,38.7,301,38.7L301,38.7z"
});
var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M285.3,39.3h23.4v-0.6c0-5.7-4.6-10.4-10.4-10.4h-2.7c-5.7,0-10.4,4.6-10.4,10.4L285.3,39.3L285.3,39.3z"
});
var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M323.7,101h-2.2V27.4c0-5.6-4.5-10.1-10.1-10.1h-3.6c-5.6,0-10.1,4.5-10.1,10.1v4h-2.2v-4 c0-6.8,5.5-12.3,12.3-12.3h3.6c6.8,0,12.3,5.5,12.3,12.3L323.7,101L323.7,101z"
});
var _ref43 = /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 297,
  cy: 38.8,
  r: 4.4
});
var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M301.4,38.8c0-2.4-2-4.4-4.4-4.4s-4.4,2-4.4,4.4c0,0.2,0,0.4,0.1,0.6h8.7C301.3,39.2,301.4,39,301.4,38.8 L301.4,38.8z"
});
var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M189.5,100l0.1,99.8h143c1.8,0,3.3-1.5,3.3-3.3c0,0,0,0,0,0l-0.1-96.6L189.5,100L189.5,100z"
});
var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M43.1,100l0.1,96.6c0,1.8,1.4,3.2,3.3,3.2h143l-0.1-99.8L43.1,100L43.1,100z"
});
var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M78.8,146.6c0,0-28.4,6.4-43.3-5C16.7,127.3,19.7,106,19.7,106l-7,1.4c0,0-8.1,37.9,4,57.1 c15,23.8,49.1,22.2,49.1,22.2S78.8,146.6,78.8,146.6z"
});
var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M169.1,189.4c2.1-22.9-13.7-42.8-35.3-42.8H98.5c-21.6,0-37.3,19.9-35.3,42.8l0.9,10.5h104L169.1,189.4 L169.1,189.4z"
});
var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M55.5,190.2c4.6,4.5,13.4,2.8,13.4,2.8s41.3-44.1,24.7-46.4c-10.9-1.4-18.5,0-28,1.2 c-5.7,0.7-15.7-0.3-15.7-0.3S47.1,181.9,55.5,190.2L55.5,190.2z"
});
var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M134.6,146.2l-2.5,42.7c0,0,12.1,1.8,19.9,10.9H187C187.6,160.2,134.6,146.2,134.6,146.2L134.6,146.2z"
});
var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M181.1,177.7c-14.9-29.3-46.4-31.5-46.4-31.5l-2.5,42.7c0,0,8.7,1.3,17.4,10.9h1.7 C158.9,189,173.3,180.5,181.1,177.7L181.1,177.7z"
});
var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M132.9,131.5l0.1,11.1c0,2.2,1.9,3.7,4.2,3.9l-9.7,5.3c-8.1,3.7-17.4,3.7-25.4-0.2l-8.5-5 c2.3,0,4.2-1.9,4.2-4.2l0.1-12.3L132.9,131.5L132.9,131.5z"
});
var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M132.9,131.4v20.1l-35-0.1v-21.3L132.9,131.4z"
});
var _ref54 = /*#__PURE__*/React.createElement("circle", {
  className: "st13",
  cx: 132,
  cy: 127.3,
  r: 3.6
});
var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M117.1,144h-3.2c-8.8,0-16-7.3-16-16.1v-1.7c0-8.8,7.3-16,16.1-16h3.2c8.8,0,16,7.3,16,16.1v1.7 C133.1,136.8,125.9,144,117.1,144L117.1,144z"
});
var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M116.4,117.1c-0.3,6.9-1.7,8.3-2.7,9.6c-0.9,1.2-0.4,2.7,1.1,3.4c0.3,0.1,0.5,0.3,0.7,0.4 c0.5,0.4,0.8,1,0.8,1.7l-0.4,11.2l-15.5-1.9l2.5-24.2C102.9,117.4,116.5,112.7,116.4,117.1z"
});
var _ref57 = /*#__PURE__*/React.createElement("circle", {
  className: "st13",
  cx: 99,
  cy: 127.3,
  r: 3.6
});
var _ref58 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st16",
  cx: 109.2,
  cy: 124.6,
  rx: 1.1,
  ry: 2
});
var _ref59 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st16",
  cx: 121.8,
  cy: 124.6,
  rx: 1.1,
  ry: 2
});
var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M120.1,132.3h-0.2l-7.1,0.9h-0.1c-0.4,0.1-0.6,0.5-0.4,0.9c0.6,1.9,2.7,3.2,4.7,3c2.1-0.3,3.7-1.9,4-4 c0.1-0.4-0.2-0.7-0.6-0.8C120.3,132.3,120.2,132.3,120.1,132.3z"
});
var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M27.4,100.1c-0.2-1.7-5,1.2-5,1.2s3.7-7.4,1.9-7.8c-1.4-0.4-3.1,4.7-3.1,4.7s2.9-6.7,1.2-6.7 c-1.9,0-3.7,6.4-3.7,6.4s3.3-6.4,0.9-5.9c-1.5,0.3-2.9,6.7-2.9,6.7s2.6-4.6,1.2-4.5c-2.9,0.2-5.1,7.2-5.5,9.3c-0.5,2.9,0,5.6,0,5.6 s1.9,0.6,5.7,0.2C20.5,109.2,27.5,101.6,27.4,100.1z"
});
var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M120.5,132.4c-1.2,0.8-2.6,1.3-4,1.5c-1.6,0.2-3-0.1-4.2-0.4c0.1-0.1,0.2-0.2,0.4-0.3h0.1l7.1-0.9h0.2 C120.3,132.3,120.5,132.3,120.5,132.4z"
});
var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.8,27.2h-28.5l-2.1-1.2l2.1-1.1h28.5c0.5,0,0.9,0.5,0.9,1.2C130.7,26.7,130.2,27.2,129.8,27.2L129.8,27.2 z"
});
var _ref64 = /*#__PURE__*/React.createElement("circle", {
  className: "st19",
  cx: 115.8,
  cy: 23.4,
  r: 9.1
});
var _ref65 = /*#__PURE__*/React.createElement("circle", {
  className: "st20",
  cx: 115.8,
  cy: 23.4,
  r: 9.1
});
var _ref66 = /*#__PURE__*/React.createElement("circle", {
  className: "st19",
  cx: 115.8,
  cy: 43.2,
  r: 18
});
var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M110.3,62.7v1.2c0,1.4-1,2.7-2.4,3l-0.4,0.1l1.4,2.6h4.3v-6.9L110.3,62.7L110.3,62.7z M121.2,62v1.9 c0,1.4,1,2.7,2.4,3L124,67l-0.8,3h-4.6v-8H121.2z"
});
var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M110.3,51.7h10.9v27.1h-10.9V51.7z"
});
var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M110.3,78.8h10.9V51.7h-10.9V78.8z"
});
var _ref70 = /*#__PURE__*/React.createElement("circle", {
  className: "st21",
  cx: 115.8,
  cy: 47.6,
  r: 13.8
});
var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M115.8,35.5v25.9c7.6,0,13.8-6.2,13.8-13.8c0-5.2-2.9-9.7-7-12.1H115.8z"
});
var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M99.3,70.5h32.9c-4.6-2.9-10-4.5-15.5-4.5h-1.9C109.3,66,104,67.6,99.3,70.5z"
});
var _ref73 = /*#__PURE__*/React.createElement("circle", {
  className: "st24",
  cx: 110,
  cy: 49.6,
  r: 4.7
});
var _ref74 = /*#__PURE__*/React.createElement("circle", {
  className: "st24",
  cx: 121.3,
  cy: 49.6,
  r: 4.7
});
var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M114.6,48.2h2.2"
});
var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M133.7,53.8c-4.5,0.1-8.2-1.7-8.2-1.7c-0.4-0.3-0.1-0.6,0.4-0.7c0.7-0.1,1.5-0.2,2.2-0.4l-2.5-3.8 c-0.4-0.3-0.1-1.5,0.9-0.9s1.7,0.9,3.3,1.7c1.7,0.8,4.8,4.2,4.8,4.2L133.7,53.8L133.7,53.8z"
});
var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M124,67h15.2c1.5,0,2.1-1.9,0.9-2.7l-9.1-6.6l3.2-5.9l22.4,7c10.6,3.4,11.4,18,1.2,22.6L131.4,93L124,67z"
});
var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M113.2,54.8c0.3,0.4,0.6,0.5,0.9,0.7c0.3,0.1,0.6,0.2,0.9,0.3c0.4,0.1,0.6,0.1,1,0.1c0.4,0,0.7,0,1.2-0.1h0.1 c0.1-0.1,0.4,0.1,0.4,0.2v0.2c-0.2,0.6-0.7,1-1.2,1.2c-0.6,0.2-1.2,0.2-1.7,0.1c-0.6-0.1-1.1-0.4-1.5-0.9c-0.4-0.4-0.6-1.1-0.5-1.7 c0-0.2,0.2-0.3,0.4-0.3C113.1,54.8,113.1,54.8,113.2,54.8z"
});
var _ref79 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st16",
  cx: 110,
  cy: 49.9,
  rx: 1.1,
  ry: 1.8
});
var _ref80 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st16",
  cx: 121.2,
  cy: 49.9,
  rx: 1.1,
  ry: 1.8
});
var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M133.7,43.2c0,1-0.1,2-0.3,3c-5.1-0.3-9.6-3.1-12.3-7.1c1.7-2.5,2.7-5.5,2.7-8.8c0-1.2-0.1-2.2-0.4-3.3 C129.5,29.9,133.7,36.1,133.7,43.2z"
});
var _ref82 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M123.5,26.9c0.2,1.1,0.4,2.2,0.4,3.3c0,3.2-0.9,6.3-2.7,8.8c-1.7-2.5-2.7-5.5-2.7-8.8c0-1.7,0.3-3.2,0.7-4.7 C120.8,25.9,122.2,26.4,123.5,26.9z"
});
var _ref83 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M121.2,39.1c-3,4.5-8,7.1-13.3,7.1c-3.8,0-7.3-1.4-10.1-3.6c0.3-9.6,8.2-17.4,18-17.4c1.2,0,2.4,0.1,3.5,0.4 c-0.4,1.5-0.7,3.1-0.7,4.7C118.5,33.5,119.5,36.6,121.2,39.1z"
});
var _ref84 = /*#__PURE__*/React.createElement("circle", {
  className: "st25",
  cx: 18.5,
  cy: 17.9,
  r: 17.5
});
var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M21.2,11.5c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.4,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7v9.1 c0,0.3-0.1,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.2-0.4,0.4-0.6,0.4c-0.2,0.1-0.5,0.1-0.7,0.1H10.4c-0.7,0-1.3-0.4-1.7-1.1 c-0.3-0.6-0.5-1.4-0.6-2.4C8,20.3,8,19.6,8,18.7v-1.7c0-0.9,0-1.7,0.1-2.2c0.1-1,0.4-1.8,0.6-2.4c0.4-0.7,0.9-1.1,1.7-1.1h10.1 C20.8,11.3,21,11.4,21.2,11.5z M28.7,12.8c0.1,0.1,0.2,0.3,0.2,0.4v9.1c0,0.1-0.1,0.4-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 S28,23,27.9,22.8l-3.3-3.2c-0.3-0.2-0.4-0.5-0.6-0.9c-0.1-0.4-0.2-0.6-0.2-1s0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.6-0.9l3.3-3.2 c0.1-0.1,0.3-0.2,0.4-0.2C28.5,12.6,28.7,12.7,28.7,12.8z"
});
var _ref86 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 216.8,
  cy: 128.5,
  r: 12.7
});
var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M212.5,121.5l4.3,7l6.2,0.1"
});
var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M311.8,178.4c-1.5-6-13-5.3-14.4-10.7c-1.5-5.5,4.3-10,1.7-15.1c-2.6-5.1-8.7-5-12.3-9.9 c-3.6-4.8-4.8-15.6-4.8-15.6l-17.2-8l-1.1,4.9l-1.2-5.4l-17.3,8.5c0,0-1.3,10.8-5,15.7s-10.5,4.5-13.2,9.7 c-2.7,5.2,3.8,10.1,2.3,15.6c-1.5,5.5-12.1,5.4-14.5,11.2c-3.9,9.2,8.9,10.9,8.9,16.1c0,2.4-1.7,3.3-3.8,4.4h90 c-3.4-1.6-7.1-1.9-7-5C302.8,189.6,314.2,188.5,311.8,178.4L311.8,178.4z"
});
var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M253.6,161l-8.4,9.9l1.1,17.4c1.4,3.7,2.1,7.6,2.2,11.5h30.4c0.1-3.9,0.8-7.8,2.2-11.5l3.4-9.9l-9.6-17.4 L253.6,161L253.6,161z"
});
var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M289.4,171.5c-2.8-8-14.5-10.5-14.5-10.5s1.3,23.3,4.1,38.8l12.2,0C290.1,189.1,291.2,176.8,289.4,171.5 L289.4,171.5z"
});
var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M283.1,133.1c0,0.9-0.1,1.7-0.1,2.5c-0.5,4.6-2.5,8.7-5.5,11.8c-3.5,3.7-8.3,5.9-13.6,5.9h-0.3 c-9.9,0-18-7.8-19.1-17.9c-0.1-0.8-0.1-1.6-0.1-2.4c0-4.9,1.9-9.3,4.9-12.4c1.5-1.5,3.2-2.8,5.1-3.7c2.1-1,4.4-1.5,6.7-1.5h5.4 c2.4,0,4.7,0.5,6.8,1.5C279,119.8,283.1,125.9,283.1,133.1L283.1,133.1z"
});
var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M259.7,145.3h8.1v16.4h-8.1V145.3z"
});
var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M270.5,151.6l-1.5,0.6c-0.8,0.3-1.3,1.1-1.3,1.9v1.7c0,1.8,1.3,3.5,3.1,3.9l0.3,0.1l-7.1,1.6l-7.1-1.7 c1.6-0.5,2.7-2,2.7-3.7v-1.9c0-0.8-0.5-1.6-1.3-1.9l-1.5-0.6L270.5,151.6L270.5,151.6z"
});
var _ref94 = /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M263.9,153.4h-0.3c-7.5,0-13.6-6.1-13.6-13.6v-0.1c0-6.5,5.3-11.8,11.8-11.8h3.9c6.5,0,11.8,5.3,11.8,11.8 v0.1C277.4,147.3,271.4,153.4,263.9,153.4L263.9,153.4z"
});
var _ref95 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st5",
  cx: 269.1,
  cy: 140.5,
  rx: 1.2,
  ry: 2.1
});
var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M253.7,137.2h10.1v11h-10.1V137.2z"
});
var _ref97 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st5",
  cx: 258.2,
  cy: 140.5,
  rx: 1.2,
  ry: 2.1
});
var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M282.2,136.7c-1.4,0.7-2.9,1.1-4.5,1.1c-5.1,0-9.3-4-9.7-9.1h-8.4c-0.3,5.1-4.6,9.1-9.7,9.1 c-1.7,0-3.3-0.4-4.8-1.2c-0.1-0.7,6-13.6,6-13.6h25.6C276.8,123,282.3,136,282.2,136.7z"
});
var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M268,127.9c0,0,0,0.9,0,0.9l-4.2,0v-0.9c0.1-1.2,1.2-2,2.3-1.9C267.2,126.1,268,126.9,268,127.9z  M263.8,127.9L263.8,127.9l0,0.9h-4.2v-0.9c0.1-1.2,1.1-2,2.3-1.9C262.9,126.1,263.7,126.9,263.8,127.9z"
});
var _ref100 = /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M265,137.1c0,0-0.8,0.3-1.2,2.3c-0.5,2.5-2.3,2.6-1.9,4.5c0.3,1,1.7,1.6,1.9,2.3 C263.8,146.2,268.2,145.4,265,137.1z"
});
var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M262.1,148c0.9,0.1,1.5,0.1,2.2-0.1c0.3-0.1,0.7-0.2,1-0.3c0.4-0.1,0.7-0.3,1.1-0.5l0,0c0.2-0.1,0.4,0,0.5,0.1 c0,0.1,0,0.1,0,0.2c0,0.6-0.3,1.1-0.8,1.4c-0.4,0.4-0.9,0.6-1.5,0.8c-0.6,0.1-1.1,0.1-1.7-0.1c-0.5-0.2-1-0.6-1.2-1 c-0.1-0.2,0-0.4,0.1-0.5C261.9,148,262,147.9,262.1,148L262.1,148z"
});
var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M247.6,192.4c0.9-1.8,3.7-10,3.7-10l2.3-21.4c0,0-11.7,2.5-14.5,10.5c-2.2,6.3-2.3,19.2-7.4,27.9 C238,200.3,247.6,192.4,247.6,192.4z"
});
var _ref103 = /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M271.1,163c-4.5,3.1-10.5,3.1-15-0.1c-0.9-0.6-1.7-1.2-2.6-1.9c1.2-0.4,2.2-0.7,2.6-0.9 c2.8-1.2,4.4-1.5,7.5-1.5c0.9,0,2.4,0.1,4,0.4c3.2,0.6,7.2,2,7.2,2L271.1,163L271.1,163z M253.4,179.7l1.8-9.1 c0.2-1,0.9-1.8,1.8-2.1l2.9-1.2c0.5-0.3,1.2-0.3,1.7,0c0,0,3.2,1.8,3.3,2.1c0.6,1.7-1.9,0.5-1.9,0.5l1.1,1c0.5,0.5,0.7,1.2,0.5,1.8 l-2.1,3.1c-0.2,0.1-0.4,0.1-0.6,0c0-0.1-0.1-0.1-0.1-0.2l-0.4-1.8l-1.8-0.4c0,0-1-0.8-1.1,6.2c0,2.8-3.2,4-3.2,4"
});
var _ref104 = /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M231.4,199.8h13.7c5-7.2,10.1-16.2,10.1-16.2l-1.9-3.9C253.4,179.7,235.3,193.1,231.4,199.8z"
});
var _ref105 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 217.1,
  cy: 128.6,
  r: 12.7
});
var _ref106 = /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M212.8,121.6l4.3,7l6.2,0.1"
});
var _ref107 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M327.8,194.8h-30.7c-2.1,0-3.7-1.6-3.7-3.7c0,0,0,0,0-0.1v-18.8c0-2.1,1.6-3.7,3.7-3.7c0,0,0,0,0.1,0h30.7 c2.1,0,3.7,1.6,3.7,3.7c0,0,0,0,0,0.1v18.8C331.6,193.2,329.9,194.8,327.8,194.8C327.9,194.8,327.9,194.8,327.8,194.8z"
});
var _ref108 = /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M317.6,180.9h0.6c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0,0.6-0.2,1.1-0.6,1.4 c-0.4,0.4-0.9,0.6-1.4,0.6h-0.6L317.6,180.9L317.6,180.9z M306.9,181h-0.6c-0.6,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4 c0,0.6,0.2,1,0.6,1.4c0.4,0.4,0.9,0.6,1.4,0.6h0.6L306.9,181L306.9,181z"
});
var _ref109 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M314.2,181.7c0-0.2,0.1-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.4-0.3s0.2,0.1,0.4,0.3c0.1,0.1,0.1,0.4,0.1,0.6 s-0.1,0.5-0.1,0.6c-0.1,0.1-0.2,0.3-0.4,0.3s-0.2-0.1-0.4-0.3C314.2,182.1,314.2,181.9,314.2,181.7z"
});
var _ref110 = /*#__PURE__*/React.createElement("path", {
  className: "st34",
  d: "M307.9,180.7h4v4.9h-4V180.7z"
});
var _ref111 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M309.2,181.7c0-0.2,0.1-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.4-0.3s0.2,0.1,0.4,0.3c0.1,0.1,0.1,0.4,0.1,0.6 s-0.1,0.5-0.1,0.6c-0.1,0.1-0.2,0.3-0.4,0.3c-0.1,0-0.2-0.1-0.4-0.3C309.2,182.2,309.2,182,309.2,181.7z"
});
var _ref112 = /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M311.5,185.4c0.1,0,0.3,0,0.5-0.1c0.1-0.1,0.4-0.1,0.5-0.1l0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.1-0.1,0.2,0l0.1,0.1c0,0.3-0.1,0.5-0.3,0.7c-0.1,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.1-0.7,0.1c-0.3,0-0.5-0.1-0.6-0.4 C311.3,185.5,311.4,185.4,311.5,185.4C311.4,185.4,311.4,185.4,311.5,185.4L311.5,185.4z"
});
var _ref113 = /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M312.9,182.9c0,0.6-0.5,2.1-0.9,2.2c0,0,0-0.1-0.1-0.4c-0.1-0.4-0.3-0.7-0.6-0.9c-0.3-0.1-0.6-0.4-0.6-1 s0.4-0.9,0.7-1c0.3-0.1,0.5-0.5,0.5-0.8c0.1-0.4,0.1-0.6,0.1-0.6C312.3,180.7,312.9,182.5,312.9,182.9L312.9,182.9z"
});
var _ref114 = /*#__PURE__*/React.createElement("path", {
  className: "st36",
  d: "M312.4,190.8c-5.4,0-9.7-4.3-9.7-9.7s4.3-9.7,9.7-9.7s9.7,4.3,9.7,9.7C322.1,186.4,317.7,190.8,312.4,190.8z"
});
var _ref115 = /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M312.4,193c-1.2,0-2.2-1-2.2-2.2v-4.7h4.3v4.7C314.5,192,313.6,193,312.4,193L312.4,193z"
});
var _ref116 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M303.3,194.8h18.3c-2.2-2.9-5.5-4.5-9.1-4.5C308.8,190.3,305.4,192,303.3,194.8z"
});
var _ref117 = /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M312.4,188.2c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5C318.9,185.3,316,188.2,312.4,188.2 C312.4,188.2,312.4,188.2,312.4,188.2z"
});
var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "st36",
  d: "M319.4,180c-3.8,0-7-3.1-7-6.9c0,0,0-0.1,0-0.1h2.9c2.2,0,4,1.8,4,4c0,0,0,0,0,0L319.4,180L319.4,180z"
});
var _ref119 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.8,27.2h-28.5l-2.1-1.2l2.1-1.1h28.5c0.5,0,0.9,0.5,0.9,1.2C130.7,26.7,130.2,27.2,129.8,27.2L129.8,27.2 z"
});
var _ref120 = /*#__PURE__*/React.createElement("circle", {
  className: "st19",
  cx: 115.8,
  cy: 23.4,
  r: 9.1
});
var _ref121 = /*#__PURE__*/React.createElement("circle", {
  className: "st37",
  cx: 115.8,
  cy: 23.4,
  r: 9.1
});
var _ref122 = /*#__PURE__*/React.createElement("circle", {
  className: "st19",
  cx: 115.8,
  cy: 43.2,
  r: 18
});
var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M110.3,62.7v1.2c0,1.4-1,2.7-2.4,3l-0.4,0.1l1.4,2.6h4.3v-6.9L110.3,62.7L110.3,62.7z M121.2,62v1.9 c0,1.4,1,2.7,2.4,3L124,67l-0.8,3h-4.6v-8H121.2z"
});
var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M110.3,51.7h10.9v27.1h-10.9V51.7z"
});
var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M110.3,78.8h10.9V51.7h-10.9V78.8z"
});
var _ref126 = /*#__PURE__*/React.createElement("circle", {
  className: "st21",
  cx: 115.8,
  cy: 47.6,
  r: 13.8
});
var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M115.8,35.5v25.9c7.6,0,13.8-6.2,13.8-13.8c0-5.2-2.9-9.7-7-12.1H115.8z"
});
var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M145.8,100v-4.8c0-9-4.1-17-10.4-22.4c-1-0.9-2-1.6-3.2-2.3H99.4c-0.7,0.4-1.4,0.9-2.2,1.5 c-7,5.3-11.5,13.7-11.5,23.2v4.8L145.8,100C145.8,100,145.8,100,145.8,100z"
});
var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M99.3,70.5h32.9c-4.6-2.9-10-4.5-15.5-4.5h-1.9C109.3,66,104,67.6,99.3,70.5z"
});
var _ref130 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M107.4,100V67C96,69.9,87.3,79.6,85.7,91.6v0.1c-0.1,0.3-0.6,3.7-1.6,8.3L107.4,100L107.4,100z"
});
var _ref131 = /*#__PURE__*/React.createElement("path", {
  className: "st40",
  d: "M147.2,100c-1-4.7-1.5-8.1-1.6-8.3v-0.1C144.1,79.6,135.4,69.9,124,67v33L147.2,100L147.2,100z"
});
var _ref132 = /*#__PURE__*/React.createElement("circle", {
  className: "st24",
  cx: 110,
  cy: 49.6,
  r: 4.7
});
var _ref133 = /*#__PURE__*/React.createElement("circle", {
  className: "st24",
  cx: 121.3,
  cy: 49.6,
  r: 4.7
});
var _ref134 = /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M114.6,48.2h2.2"
});
var _ref135 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M133.7,53.8c-4.5,0.1-8.2-1.7-8.2-1.7c-0.4-0.3-0.1-0.6,0.4-0.7c0.7-0.1,1.5-0.2,2.2-0.4l-2.5-3.8 c-0.4-0.3-0.1-1.5,0.9-0.9s1.7,0.9,3.3,1.7c1.7,0.8,4.8,4.2,4.8,4.2L133.7,53.8L133.7,53.8z"
});
var _ref136 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M124,67h15.2c1.5,0,2.1-1.9,0.9-2.7l-9.1-6.6l3.2-5.9l22.4,7c10.6,3.4,11.4,18,1.2,22.6L131.4,93L124,67z"
});
var _ref137 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M113.4,54.8c0.3,0.4,0.6,0.5,0.9,0.7c0.3,0.1,0.6,0.2,0.9,0.3c0.4,0.1,0.6,0.1,1,0.1c0.4,0,0.7,0,1.2-0.1h0.1 c0.1-0.1,0.4,0.1,0.4,0.2v0.2c-0.2,0.6-0.7,1-1.2,1.2c-0.6,0.2-1.1,0.2-1.7,0.1c-0.6-0.1-1.2-0.4-1.5-0.9c-0.4-0.4-0.6-1.1-0.5-1.7 c0-0.2,0.2-0.3,0.4-0.3C113.3,54.8,113.3,54.8,113.4,54.8z"
});
var _ref138 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st16",
  cx: 110,
  cy: 49.9,
  rx: 1.1,
  ry: 1.8
});
var _ref139 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st16",
  cx: 121.2,
  cy: 49.9,
  rx: 1.1,
  ry: 1.8
});
var _ref140 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M97.8,42.6c2.8,2.2,6.3,3.6,10.1,3.6c5.3,0,10.3-2.6,13.3-7.1c2.7,4,7.2,6.8,12.3,7.1c0.2-1,0.3-2,0.3-3 c0-3.8-9-13.5-18.4-14.3C107.3,28.1,98.9,35.4,97.8,42.6L97.8,42.6z"
});
var _ref141 = /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M139,199.8v-28.5c0-1.8-1.5-3.3-3.3-3.3c0,0,0,0,0,0h-29.3c-1.8,0-3.3,1.5-3.3,3.3c0,0,0,0,0,0v28.5 L139,199.8L139,199.8L139,199.8z"
});
var _ref142 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M107.7,180.7c-0.4-0.4-1.1-0.6-1.7-0.4c-1,0.4-1.4,1.6-0.9,2.4l3.2,4.1l-8.3-1.7c-1.1-0.2-2.2,0.6-2.2,1.7 c0,0.7,0.5,1.4,1.1,1.7l0.9,0.4l0.6,6.3c0.1,1.3,1.1,2.4,2.4,2.7l8.9,1.6c0.4,0.1,0.7,0.2,1,0.4h17.8L107.7,180.7z"
});
function SvgSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 377.1 200",
    style: {
      enableBackground: "new 0 0 377.1 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.0844,
    y1: 319.8171,
    x2: 260.0844,
    y2: 292.1772,
    gradientTransform: "matrix(1 0 0 1 0 -205.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 356.53,
    cy: 306.7986,
    r: 7.4499,
    gradientTransform: "matrix(0.9701 1.230000e-02 -1.110000e-02 0.8744 -83.0713 -230.9765)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9B643D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF8F68",
      stopOpacity: 0
    }
  })), _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: -642.856,
    cy: -1996.787,
    r: 20.8105,
    gradientTransform: "matrix(-0.998 0 0 -0.7523 -526.007 -1366.7914)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#591C17"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#7B422B",
      stopOpacity: 0.454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B643D",
      stopOpacity: 0
    }
  })), _ref53, _ref54, _ref55, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 2438.3447,
    cy: 264.2685,
    r: 8.537,
    gradientTransform: "matrix(0.9781 6.820000e-02 -4.570000e-02 0.6563 -2256.3943 -211.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593417"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B643D",
      stopOpacity: 0
    }
  })), _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 136.2481,
    cy: -204.6822,
    r: 15.2471,
    gradientTransform: "matrix(0.998 0 0 0.998 -19.7599 236.1821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    style: {
      stopColor: "#493931",
      stopOpacity: 0.286
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594539",
      stopOpacity: 0
    }
  })), _ref65, _ref66, _ref67, _ref68, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: -3313.4756,
    cy: -180.2818,
    r: 10.3597,
    gradientTransform: "matrix(-0.998 0 0 0.998 -3191.1799 236.1811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#9B643D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "#B98963",
      stopOpacity: 0.545
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95",
      stopOpacity: 0
    }
  })), _ref69, _ref70, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -3331.0598,
    y1: -195.1544,
    x2: -3316.4353,
    y2: -188.1618,
    gradientTransform: "matrix(-1 0 0 1 -3199.2048 236.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9B643D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    style: {
      stopColor: "#B98963",
      stopOpacity: 0.545
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95",
      stopOpacity: 0
    }
  })), _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 241.3249,
    cy: 396.0522,
    r: 23.9495,
    gradientTransform: "matrix(0.998 0 0 0.998 7.813440e-02 -204.9149)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007000001,
    style: {
      stopColor: "#33312D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    style: {
      stopColor: "#3D3B37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#5E5B58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#726F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#797673"
    }
  })), _ref89, _ref90, _ref91, _ref92, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 1395.7695,
    cy: 352.1974,
    r: 8.921,
    gradientTransform: "matrix(-0.998 0 0 0.998 1654.472 -204.9149)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9B643D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#A36E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    style: {
      stopColor: "#D2A987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#EFCEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FADCBD"
    }
  })), _ref93, _ref94, _ref95, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 2589.8223,
    cy: 6731.479,
    r: 12.4492,
    gradientTransform: "matrix(0.5335 0 0 0.4356 -1117.1987 -2789.1055)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9B643D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    style: {
      stopColor: "#B78763",
      stopOpacity: 0.678
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FADCBD",
      stopOpacity: 0
    }
  })), _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 243.5808,
    cy: 407.0732,
    r: 17.887,
    gradientTransform: "matrix(0.998 0 0 0.998 7.813440e-02 -204.9149)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007000001,
    style: {
      stopColor: "#33312D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    style: {
      stopColor: "#3D3B37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#5E5B58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#726F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#797673"
    }
  })), _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 6025.5933,
    cy: 983.0483,
    r: 3.1589,
    gradientTransform: "matrix(-0.998 -1.500000e-03 0 0.7381 6325.0537 -533.6469)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#744D2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE906B",
      stopOpacity: 0
    }
  })), _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 136.2481,
    cy: -204.6822,
    r: 15.2471,
    gradientTransform: "matrix(0.998 0 0 0.998 -19.7599 236.1821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    style: {
      stopColor: "#493931",
      stopOpacity: 0.286
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594539",
      stopOpacity: 0
    }
  })), _ref121, _ref122, _ref123, _ref124, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: -3313.4756,
    cy: -180.2818,
    r: 10.3597,
    gradientTransform: "matrix(-0.998 0 0 0.998 -3191.1799 236.1811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#9B643D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "#B98963",
      stopOpacity: 0.545
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95",
      stopOpacity: 0
    }
  })), _ref125, _ref126, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -3332.0024,
    y1: -195.6052,
    x2: -3317.3779,
    y2: -188.6125,
    gradientTransform: "matrix(-1 0 0 1 -3199.2048 236.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9B643D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    style: {
      stopColor: "#B98963",
      stopOpacity: 0.545
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95",
      stopOpacity: 0
    }
  })), _ref127, _ref128, _ref129, _ref130, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 148.213,
    cy: 345.6078,
    r: 15.0902,
    gradientTransform: "matrix(0.998 0 0 -0.998 7.813440e-02 427.3659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#6E6FAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#9A9BC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    style: {
      stopColor: "#BEBFDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    style: {
      stopColor: "#DBDBEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    style: {
      stopColor: "#EFEFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    style: {
      stopColor: "#FBFBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.ed145fdfc7e2f24ff820c820a69a1b7a.svg";
export { ForwardRef as ReactComponent };